interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  label?: string;
  fullPage?: boolean;
}

const SIZE_MAP = {
  sm: 'h-4 w-4 border-2',
  md: 'h-8 w-8 border-2',
  lg: 'h-12 w-12 border-3',
};

export default function LoadingSpinner({
  size = 'md',
  className = '',
  label,
  fullPage = false,
}: LoadingSpinnerProps) {
  const spinner = (
    <div className={`flex flex-col items-center gap-3 ${className}`}>
      <div
        className={`animate-spin rounded-full border-line border-t-orn-600 ${SIZE_MAP[size]}`}
        role="status"
        aria-label={label ?? 'Loading'}
      />
      {label && <p className="text-sm text-content-muted">{label}</p>}
    </div>
  );

  if (fullPage) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">{spinner}</div>
    );
  }

  return spinner;
}
